<i class="material-icons" [ngClass]="category"></i>
